<!-- <div class="p-20" fxLayout="column" fxLayoutAlign="start stretch" > -->
<div class="p-20" fxLayout="row wrap" fxLayoutAlign="center">
    <ng-container *ngIf="!flagCierre">
        <div fxLayout="column" fxLayoutAlign="start center" fxFlex="100">

            <h1>{{'CIERRE.LABEL1' | translate}}</h1>
            <mat-progress-bar mode="determinate" value="{{ porcentaje }}" style="height: 20px;"></mat-progress-bar>
            <h3>{{ porcentaje }}%</h3>
            <!-- <h1>{{'CIERRE.LABEL2' | translate}}</h1>
      <a href="{{ url }}" target="_blank">{{ url }}</a>
      <button *ngIf="!flagCierre" mat-raised-button color="accent" (click)="showAlert();" class="mt-20">
        {{'CIERRE.BTN_CIERRE' | translate}}
      </button> -->
        </div>

        <div class="mt-40" fxFlex="100" fxLayout="row" fxLayoutAlign="space-around stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
            <div class="mat-elevation-z3 p-20" fxFlex="100" fxLayout="column" fxLayoutAlign="start stretch">
                <h2 class="mt-0">{{'CIERRE.LABEL2' | translate}}</h2>
                <mat-divider></mat-divider>
                <div class="mt-20 mb-20">
                    <div class="h4 secondary-text mb-20">{{'CIERRE.LINK' | translate}}</div>
                    <!-- <a href="{{ url }}" target="_blank">{{ url }}</a> -->
                </div>
                <div class="mt-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch">
                    <button mat-raised-button class="mb-20 accent" [routerLink]="'/portalControl/'">
            {{'CIERRE.CIERRE.BCONTEOS' | translate}}
              <mat-icon class="ml-20">poll</mat-icon>
            </button>
                    <ng-container *ngIf="!claveConteos">
                        <button mat-raised-button class="mb-20" (click)="generarClave()">
          {{'CIERRE.CIERRE.BACCESO' | translate}}
                <mat-icon class="ml-20">vpn_key</mat-icon>
              </button>
                        <div class="h4 secondary-text mb-20">{{'CIERRE.LINKENCUESTA' | translate}}</div>

                    </ng-container>
                    <ng-container *ngIf="claveConteos">
                        <button mat-raised-button class="mb-20" (click)="copyMessage(claveConteos)" value="click to copy">
              {{'CIERRE.CIERRE.LINKPORTAL' | translate}}
                <mat-icon class="ml-20 ">vpn_key</mat-icon>
              </button>
                    </ng-container>
                    <ng-container>
                        <button mat-raised-button class="mb-20 accent" (click)="sendReminder()">
                        {{'CIERRE.CIERRE.REMANDER' | translate}}
                        <mat-icon class="ml-20">email</mat-icon>
                      </button>


                    </ng-container>
                </div>

            </div>
            <!-- div cerrar encuesta-->
            <!-- <div class="mat-elevation-z3 p-20" fxFlex="40" fxLayout="column" fxLayoutAlign="start stretch">
        <h2 class="mt-0">{{'CIERRE.ACTIONS.TITULO' | translate}}</h2>
        <mat-divider></mat-divider>
        <div class="mt-20" fxLayout="column" fxLayoutAlign="start center">
          <div class="h4 secondary-text">{{'CIERRE.ACTIONS.WANNADO' | translate}}</div>
          <div class="mt-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch">
            <button mat-raised-button class="mb-20 accent" (click)="showAlert()" >
              {{'CIERRE.BTN_CIERRE' | translate}}
              <mat-icon class="ml-20">power_settings_new</mat-icon>
            </button>
          </div>
        </div>

      </div> -->
        </div>

    </ng-container>

    <ng-container *ngIf="flagCierre">

        <div class="statusDiv" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
            <div class="roundEdg done mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                <h2>{{'CIERRE.COMPLETO.TAG' | translate}}</h2>
                <mat-icon class="ml-20 s-40">check_circle</mat-icon>
            </div>
        </div>

        <div class="mt-40" fxFlex="100" fxLayout="row" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
            <div class="mat-elevation-z3 p-20" fxFlex="60" fxLayout="column" fxLayoutAlign="start stretch">
                <h2 class="mt-0">{{'CIERRE.COMPLETO.CARDTIT' | translate}}</h2>
                <mat-divider></mat-divider>
                <div class="mt-20 mb-20">
                    <div class="h4 secondary-text mb-20">{{'CIERRE.COMPLETO.LINK' | translate}}</div>
                    <a href="{{ url }}" target="_blank">{{ url }}</a>
                </div>
            </div>
        </div>




    </ng-container>

    <!-------------boton completar paso
  <div fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">
    <button *ngIf="!pasoCompleto" (click)="completarPaso()" mat-fab aria-label="boton completar paso"
      matTooltip="{{'CERTIFICAR.ADICIONALES.STATUS.PEND' | translate}}" matTooltipPosition="left" class="undone mr-20"
      (click)="completarPaso()"
    >
      <mat-icon>done</mat-icon>
    </button>
    <button *ngIf="pasoCompleto" (click)="completarPaso()" mat-raised-button class="done mr-20">
      {{'CERTIFICAR.ADICIONALES.STATUS.DONE' | translate}}
      <mat-icon class="ml-20">done</mat-icon>
    </button>
  </div>
---------->
</div>
